import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useTenantStore } from '../stores/tenantStore';
export var TenantStoreContext = /*#__PURE__*/ React.createContext(null);
export var TenantStoreProvider = function TenantStoreProvider(param) {
    var children = param.children;
    var tenantStoreState = useTenantStore();
    return /*#__PURE__*/ _jsx(TenantStoreContext.Provider, {
        value: tenantStoreState,
        children: children
    });
};
export var useTenantStoreContext = function useTenantStoreContext() {
    var context = React.useContext(TenantStoreContext);
    if (!context) {
        throw new Error('useTenantStoreContext must be used within TenantStoreProvider');
    }
    return context;
};
